import React, { useRef } from 'react';
import html2canvas from 'html2canvas';

const App = () => {
  const elementRef = useRef(null);
  const downloadLinkRef = useRef<HTMLAnchorElement>(null);

  const handleCaptureClick = async () => {
    if (elementRef.current) {
      const canvas = await html2canvas(elementRef.current);
      const imgData = canvas.toDataURL('image/png');

      // 设置下载链接的 href 属性为图片数据
      if (downloadLinkRef.current) {
        downloadLinkRef.current.href = imgData;
        downloadLinkRef.current.download = 'captured-image.png';
        // 触发下载
        downloadLinkRef.current.click();
      }
    }
  };

  return (
    <div>
      <div
        ref={elementRef}
        style={{
          padding: '20px',
          backgroundColor: '#f5da55',
          borderRadius: '10px',
        }}
      >
        <h1 style={{ color: '#000' }}>Hello, World!</h1>
      </div>
      <button onClick={handleCaptureClick}>Capture and Download</button>
      <a ref={downloadLinkRef} style={{ display: 'none' }}></a>
    </div>
  );
};

export default App;
